import React from "react";
import MuiListItem from "@material-ui/core/ListItem";
import PropTypes from "prop-types";

/**
 * ListItem component wrapper for list items.
 * Wraps Material-UI ListItem with theme integration.
 * 
 * @component
 * @example
 * <ListItem button onClick={handleClick}>
 *   <ListItemText primary="Item 1" />
 * </ListItem>
 */
const ListItem = ({ children, ...props }) => {
  return <MuiListItem {...props}>{children}</MuiListItem>;
};

ListItem.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * Defines the align-items style property
   */
  alignItems: PropTypes.oneOf(["flex-start", "center"]),
  /**
   * If true, the list item is a button
   */
  button: PropTypes.bool,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * If true, compact vertical padding designed for keyboard and mouse input is used
   */
  dense: PropTypes.bool,
  /**
   * If true, the component is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If true, the left and right padding is removed
   */
  disableGutters: PropTypes.bool,
  /**
   * If true, a 1px light border is added to the bottom of the list item
   */
  divider: PropTypes.bool,
  /**
   * Use to apply selected styling
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI ListItem behavior

export default ListItem;

